export const METAL_BAND_COLOR = "#aaaaaa"
export const METAL_BAND_THRESHOLD = 100
export const MAX_SCOPE_WORKFLOW_SECTIONS = 10
export const CAMERA_OPTICAL_DIAMETER = 36

export const MIN_TEMP = -270
export const MAX_TEMP = 1000
export const MIN_PIPE_LENGTH = 300
export const MAX_PIPE_LENGTH = 10000
export const MIN_PIPE_DIAMETER = 25
export const MAX_PIPE_DIAMETER = 1000
export const MIN_THICKNESS = 0
export const MAX_THICKNESS = 1000
export const MAX_SECTION_LENGTH = 2000
export const MIN_SECTION_LENGTH = 300

export const MAX_QR_CODE_CHARS = 2225
export const MAX_WORKFLOWS_TO_LOAD = 25